import { useDispatch, useSelector } from 'react-redux'
import { LuChevronsUpDown } from 'react-icons/lu'
import { FiLogOut } from 'react-icons/fi'
import Avatar from './Avatar'
import SidebarMenu from './SidebarMenu'
import { signoutRequest } from '../redux/action/signinAction'
import ThemeToggle from './ThemeToggle'

/* ============================================================================
   Account row in the sidebar footer — avatar, name, email, chevron — and the
   menu behind it (appearance + sign out). The menu unfolds upward out of the
   row itself (see SidebarMenu), so the row doubles as the menu's header and
   there is no second copy of the name inside it.

   Collapsed to the rail the row is only the avatar; the card widens past the
   rail there and the name/email ride along in its bottom strip, beside the
   avatar, so the rail still says whose account this is.
   ========================================================================== */
const SidebarUser = ({ collapsed }) => {
  const dispatch = useDispatch()
  const signdata = useSelector((state) => state.signinReducers)

  const logout = () => {
    dispatch(signoutRequest())
  }

  const firstName = signdata?.data?.first_name ?? ''
  const lastName = signdata?.data?.last_name ?? ''
  const email = signdata?.data?.email ?? ''
  const pic = signdata?.data?.profile_pic

  const meta = (
    <span className="sb-user-meta">
      <span className="sb-user-name">
        {firstName} {lastName}
      </span>
      <span className="sb-user-mail">{email}</span>
    </span>
  )

  return (
    <SidebarMenu
      collapsed={collapsed}
      label={`${firstName} ${lastName}`}
      railWidth={240}
      railLabel={meta}
      triggerClassName="sb-user"
      trigger={
        <>
          <Avatar
            src={pic}
            first={firstName}
            last={lastName}
            fallback={email}
            className="avatar-sm sb-user-avatar"
          />
          {collapsed ? null : (
            <>
              {meta}
              <LuChevronsUpDown className="sb-user-chev" aria-hidden="true" />
            </>
          )}
        </>
      }
    >
      <ThemeToggle />
      <div className="sb-menu-sep" />
      <div className="sb-menu-list">
        <button
          type="button"
          className="sb-menu-row is-danger"
          onClick={logout}
        >
          <FiLogOut className="sb-menu-row-icon" aria-hidden="true" />
          <span>Sign Out</span>
        </button>
      </div>
    </SidebarMenu>
  )
}

export default SidebarUser
